import { createConfirmation } from "react-confirm";
import EventEditModal from "./EventEditModal";

export const showEventEditModal = createConfirmation(EventEditModal);
